export function downloadFromDirectUrl(fileUrl: string, filename?: string) {
	const a = document.createElement('a')
	a.href = fileUrl
	a.download = filename || ''
	a.style.display = 'none'
	a.target = '_blank'
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a)
}

export function downloadContent(
	content: string,
	filename: string,
	mimeType = 'text/plain;charset=utf-8;'
) {
	const blob = new Blob([content], { type: mimeType })
	const url = URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = url
	a.download = filename
	a.click()
	URL.revokeObjectURL(url)
}

export async function downloadFromResponse(
	response: Response,
	fallbackFilename: string
): Promise<void> {
	const disposition = response.headers.get('content-disposition') ?? ''
	const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
	const filename = match ? match[1].replace(/['"]/g, '') : fallbackFilename

	const blob = await response.blob()
	const url = URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = url
	a.download = filename
	a.click()
	URL.revokeObjectURL(url)
}
